import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/authConfig';
import { apiClient } from './api/apiClient';
import { setupAuthInterceptor } from './api/authInterceptor';
import { esEmbebido, instalarPuente, simulacionPermitida } from './embebido/puenteGdGo';
import { instalarSimulador } from './embebido/simuladorPuente';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Embebida en GdGO! (#326): el puente del token, o su simulación donde el despliegue la permite. Antes del interceptor.
if (esEmbebido()) {
  if (simulacionPermitida()) {
    instalarSimulador(msalInstance);
  } else {
    instalarPuente();
  }
}

// Setup authentication interceptor for API calls
setupAuthInterceptor(apiClient, msalInstance);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();